export const supportsMultipleFiles = (max?: number) => max !== 1;
